import vpsOciTypes from './vpsOci.types';

const getVpsOciRequest = hostingId => ({ type: vpsOciTypes.GET_VPS_OCI_REQUEST, payload: hostingId });
const setVpsOciData = data => ({ type: vpsOciTypes.SET_VPS_OCI_DATA, payload: data });
const setVpsOciLoading = loading => ({ type: vpsOciTypes.VPS_OCI_SET_LOADING, payload: loading });

const statusVpsOciRequest = hostingId => ({ type: vpsOciTypes.STATUS_VPS_OCI_REQUEST, payload: hostingId });
const setStatusVpsOciData = status => ({ type: vpsOciTypes.STATUS_VPS_OCI_DATA, payload: status });
const setStatusVpsOciLoading = loading => ({ type: vpsOciTypes.STATUS_VPS_OCI_LOADING, payload: loading });

const rebootVpsRequest = hostingId => ({ type: vpsOciTypes.REBOOT_VPS_REQUEST, payload: hostingId });
const setRebootVpsLoading = loading => ({ type: vpsOciTypes.REBOOT_VPS_SET_LOADING, payload: loading });

const rebuildVpsRequest = hostingId => ({ type: vpsOciTypes.REBUILD_VPS_REQUEST, payload: hostingId });
const setRebuildVpsLoading = loading => ({ type: vpsOciTypes.REBUILD_VPS_SET_LOADING, payload: loading });
const setRebuildVpsStatus = status => ({ type: vpsOciTypes.REBUILD_VPS_SET_STATUS, payload: status });
const resetRebuildVps = () => ({ type: vpsOciTypes.REBUILD_VPS_RESET });

const changeImageVpsRequest = data => ({ type: vpsOciTypes.CHANGE_IMAGE_VPS_REQUEST, payload: data });
const setChangeImageVpsLoading = loading => ({ type: vpsOciTypes.CHANGE_IMAGE_VPS_SET_LOADING, payload: loading });
const setChangeImageVpsStatus = status => ({ type: vpsOciTypes.CHANGE_IMAGE_VPS_SET_STATUS, payload: status });
const setChangeImageVpsOciData = data => ({ type: vpsOciTypes.CHANGE_IMAGE_VPS_SET_DATA, payload: data });
const resetChangeImageVps = () => ({ type: vpsOciTypes.CHANGE_IMAGE_VPS_RESET });

const saveSshPasswordRequest = (hostingId, password, confirmPassword) => ({
  type: vpsOciTypes.SAVE_SSH_PASSWORD_REQUEST,
  payload: { hostingId, password, confirmPassword },
});
const setSaveSshPasswordLoading = loading => ({
  type: vpsOciTypes.SAVE_SSH_PASSWORD_SET_LOADING,
  payload: loading,
});
const setSaveSshPasswordSuccess = success => ({
  type: vpsOciTypes.SAVE_SSH_PASSWORD_SET_SUCCESS,
  payload: success,
});

const openSshTerminalRequest = hostingId => ({
  type: vpsOciTypes.OPEN_SSH_TERMINAL_REQUEST,
  payload: { hostingId },
});
const setOpenSshTerminalLoading = loading => ({
  type: vpsOciTypes.OPEN_SSH_TERMINAL_SET_LOADING,
  payload: loading,
});
const setOpenSshTerminalData = data => ({
  type: vpsOciTypes.OPEN_SSH_TERMINAL_SET_DATA,
  payload: data,
});

const saveTourStepRequest = ({ step, hostingId, session }) => ({
  type: vpsOciTypes.SAVE_TOUR_STEP_REQUEST,
  payload: { step, hostingId, session },
});

const getTour = ({ hostingId }) => ({
  type: vpsOciTypes.GET_TOUR_REQUEST,
  payload: { hostingId },
});

const setTourData = payload => ({
  type: vpsOciTypes.SET_TOUR_DATA,
  payload,
});

const actions = {
  data: {
    get: getVpsOciRequest,
    set: setVpsOciData,
    loading: setVpsOciLoading,
  },
  status: {
    get: statusVpsOciRequest,
    set: setStatusVpsOciData,
    loading: setStatusVpsOciLoading,
  },
  reboot: {
    request: rebootVpsRequest,
    loading: setRebootVpsLoading,
  },
  rebuild: {
    request: rebuildVpsRequest,
    loading: setRebuildVpsLoading,
    status: setRebuildVpsStatus,
    reset: resetRebuildVps,
  },
  changeImage: {
    request: changeImageVpsRequest,
    loading: setChangeImageVpsLoading,
    status: setChangeImageVpsStatus,
    set: setChangeImageVpsOciData,
    reset: resetChangeImageVps,
  },
  saveSshPassword: {
    request: saveSshPasswordRequest,
    loading: setSaveSshPasswordLoading,
    success: setSaveSshPasswordSuccess,
  },
  openSshTerminal: {
    request: openSshTerminalRequest,
    loading: setOpenSshTerminalLoading,
    set: setOpenSshTerminalData,
  },
  tour: {
    saveStep: saveTourStepRequest,
    get: getTour,
    set: setTourData,
  },
};

export default actions;
